import React, { FC } from "react";
import Modal from "../../common/form/Modal";
import ButtonTray from "../../common/form/ButtonTray";

interface props {
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    contactId?: string,
    partyId?: string,
    isReadOnly?: boolean;
}

const AccessibilityModal: FC<props> = ({ show, setShow }) => {

    return (
        <Modal
            title={"Accessibility"}
            show={show}
            setShow={setShow}
            className="w-2/3"
            fields={
                <>
                    <div className="modal-body mr-auto max-h-[70vh] overflow-auto">
                        <div className="max-w-4xl mx-auto">
                            <p className=" font-semibold mb-4">Web content accessibility compliance statement


                            </p>
                            <p className="mb-4">
                                TitleLogix Solutions, LLC is committed to facilitating the accessibility and usability of its website and TGX production platform for all our customers, including people with disabilities.  We strive to meet the standards of the World Wide Web Consortium’s Web Content Accessibility Guidelines 2.0 Level AA (WCAG 2.0 AA).  Our efforts are ongoing as technology advances.                        </p>
                            <p className="mb-4">
                                If at any time you have specific questions or concerns about the accessibility of any particular web page, please contact us. Please be sure to specify the issue, stating if the issue is with the website, or the TGX platform, and state the page in your email, and we will make all reasonable efforts to make that page accessible for you.                        </p>


                            <p>If you have question contact TItleLogix by phone at 713-453-8822 or by email at
                                <a
                                    href="mailto:inquire@titlelogixsolutions.com"
                                    className="text-highlight-4 underline"> inquire@titlelogixsolutions.com </a>
                                or by mail to:
                            </p>
                            <p className="mt-4 text-center">
                                TitleLogix Solutions, LLC<br />
                                13750 San Pedro Ave.<br />
                                Suite 730<br />
                                San Antonio, TX 78232<br />
                            </p>
                        </div>
                    </div>
                    <div className="border-t border-surface-5">
                        <ButtonTray
                            buttons={[
                                {
                                    buttonProps: {
                                        btnText: "Close",
                                        onClick: () => setShow(false),
                                        type: "submit",
                                    },
                                    buttonType: "button"

                                },

                            ]}
                            align={"end"}
                            gap={2}
                        />
                    </div>
                </>
            }
        />
    )
}

export default AccessibilityModal;